import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { isFinite, toNumber } from 'lodash';

@Directive({
  selector: 'input[numbersOnly]',
  standalone: false,
})
export class NumbersOnlyDirective {
  @Input() public allowNull = false;
  @Input() public min?: number;
  @Input() public max?: number;

  constructor(private elRef: ElementRef<HTMLInputElement>) {}

  @HostListener('blur', ['$event'])
  @HostListener('input', ['$event'])
  public onInput(event: InputEvent | FocusEvent) {
    const isInputEvent = event.type === 'input';
    const value = (event.target as HTMLInputElement).value;
    this.elRef.nativeElement.value = this.parseInput(value, !isInputEvent);
  }

  private parseInput(str: string, checkMinMax: boolean): string {
    if (str) {
      const num = toNumber(str);
      if (isFinite(num)) {
        return checkMinMax ? this.toMinMax(num) : str;
      }
    }
    return this.allowNull ? '' : String(this.min || 0);
  }

  private toMinMax(value: number) {
    const num = Math.max(Math.min(value, this.max || Number.MAX_SAFE_INTEGER), this.min || 0);
    return String(num);
  }
}
